import GLightbox from "glightbox";

jQuery(function ($) {
	const base = "gc-cwv-cards";

	const lightbox = GLightbox({
		selector: "data-glightbox",
		touchNavigation: true
	});

	$(`.${base}__open-gallary`).on("click", function () {
		lightbox.open();
	});
});
